/* eslint-disable react/prop-types */
import styled from 'styled-components';
import { useRouter } from 'next/router';
import Logo from '@comp/Logo/Logo';
import HeaderTop from '../Components/HeaderContainer';
import HeaderContent from '../Components/HeaderParent';

const HeaderContainer = styled(HeaderTop)`
  height: 56px;
  position: initial;
`;

const HeaderParent = styled(HeaderContent)`
  height: 56px;
  ${({ theme }) => `${theme.breakpoints.down('tablet')} {
      width: 768px;
      padding: 0px 20px;
    };`}

  ${({ theme }) => `${theme.breakpoints.down('mobile')} {
      width: 100%;
      padding: 0 16px;
    };`}
`;

const isSubscriptionPricingsUrl = (route) =>
  route === '/goal/[goalSlug]/[goalUID]/subscribe' ||
  route === '/combo/[comboSlug]/[comboUID]/subscribe';

const Header = ({ className }) => {
  const router = useRouter();
  const { route } = router;
  return (
    <HeaderContainer className={className}>
      <HeaderParent>
        <Logo disabled={!isSubscriptionPricingsUrl(route)} />
      </HeaderParent>
    </HeaderContainer>
  );
};

export default Header;

Header.propTypes = {};

Header.defaultProps = {
  isCheckoutUrl: false,
  isDarkModeOn: false,
  hideSearch: false,
  transparent: false,
  isLoginUrl: false
};
